import { render, staticRenderFns } from "./RemoteHornPage.vue?vue&type=template&id=875d87a6&scoped=true&"
import script from "./RemoteHornPage.vue?vue&type=script&lang=js&"
export * from "./RemoteHornPage.vue?vue&type=script&lang=js&"
import style0 from "./RemoteHornPage.vue?vue&type=style&index=0&id=875d87a6&scoped=true&lang=scss&"
import style1 from "./RemoteHornPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875d87a6",
  null
  
)

export default component.exports